// src/components/auth/Login.tsx

import React from 'react';
import { useLocation } from 'react-router-dom';
import {
    Box,
    Paper,
    Typography,
    Avatar,
    Alert,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import LoginForm from './LoginForm';

const Login: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();

    // Сообщение из навигации (например, после смены пароля)
    const message = (location.state as any)?.message;

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                p: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: { xs: 3, sm: 4 },
                    width: '100%',
                    maxWidth: 440,
                    borderRadius: 2,
                }}
            >
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <Avatar
                        sx={{
                            bgcolor: 'primary.main',
                            width: 56,
                            height: 56,
                            mx: 'auto',
                            mb: 2,
                        }}
                    >
                        <LockIcon fontSize="large" />
                    </Avatar>
                    <Typography variant={isMobile ? 'h5' : 'h4'} sx={{ fontWeight: 600, mb: 0.5 }}>
                        Вход
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Войдите в свой аккаунт репетитора
                    </Typography>
                </Box>

                {/* Сообщение после смены пароля */}
                {message && (
                    <Alert severity="success" sx={{ mb: 3 }}>
                        {message}
                    </Alert>
                )}

                <LoginForm />
            </Paper>
        </Box>
    );
};

export default Login;